<template>
    <div v-if="user && user.order">

        <div v-for='template in templates' >    
            <div v-for="item in template.items" class="px-5 delivery-option ">
                <option-box  class="title" :label="getLabel(item)" :price="loading ? '' : item.price" :checked="checked(item.name)" @onClick="toggle(item.name)" :hasCheck="false" />   

               <div class="delivery-option-content" v-if="isItemActive(item)">   

                 <div v-if="template.name === 'standard'">

                  <div v-if="item.name === 'address'">
                   <div v-if="expanded(item)">
                     <subscription-form :enabled="item.enabled"/>
                    </div>

                    <div v-if="!expanded(item)">

                     <div v-if="address && delivery">
                      <div>
                       <div>{{ delivery.name }}</div>
                       <div>{{ address.street }}</div>
                       <div>{{ address.zip_code }}, {{ address.city }}</div>
                       <div>{{ $t("components.subscription_form.default.telephone") }}: {{ delivery.phone }}</div>
                       <div v-if="delivery.notes">{{ $t("components.subscription_form.default.message") }}: {{ delivery.notes }}</div>
                     </div>
                   </div>

                   <div v-else><div class="placeholder" v-for="n in 3"></div></div>
                  </div>
                </div>
              </div>
              <div v-if="item.name === 'timeRange' && shipmentZonesStore.shipmentZones.available.length > 0 && $root.source !== 'enel'">
                <div v-if="expanded(item)">
                    <div v-if="$_deliverySelect_selectedIndexDaySelect >= 0">
                        <delivery-hours-select v-if="deliveryResolver.when() && errorTimeRange == null" :resolver="deliveryResolver" />
                        <flash
                            style="word-break: break-word"
                            v-if="errorTimeRange != null"
                            :flash="`Ops! Al momento le fasce orarie non sono selezionabili. Puoi comunque procedere e modificarle successivamente`"
                            state="success"
                        />
                    </div>
                    <div v-else class="pb-5">
                        Seleziona un giorno di consegna per impostare le fasce orarie
                    </div>
                </div>

                <div v-if="!expanded(item)">

                 <div v-if="address && delivery">
                  <div v-if="subscriptionStore.shipment_type === 'milkman' && deliveryStore.timeRanges.delivery.length > 0">
                    Fascia oraria selezionata: 
                    {{ deliveryStore.timeRanges.delivery[0].attributes.start.slice(0, -3) }} -
                    {{ deliveryStore.timeRanges.delivery[0].attributes.end.slice(0, -3) }}
                  </div>
                  <div v-else>
                   Consegna standard: 09:00 - 18:00
                  </div>
                </div>

                <div v-else>
                  <div class="placeholder" v-for="n in 3"></div>
                </div>
              </div>
            </div>
          </div>


          <div v-if="item.name === 'shipmentDay' && shipmentZonesStore.shipmentZones.available.length > 0 && $root.source !== 'enel'">
            <div v-if="expanded(item)">
              <delivery-day-select />
            </div>

            <div v-if="!expanded(item)">
              <div v-if="delivery && address">
                <div>{{ dateDelivery }}</div><br>
              </div>
              <div v-else>
                <div class="placeholder" v-for="n in 3"> </div>
              </div>
            </div>
          </div>

          <div class="flex flex-vcenter" v-if="expanded(item)" >
            <div class="flex-fill"> </div>
            <slot name="cta" />
          </div>
      

      

            <div class="link-detail pb-3"  @click="expand(item)"  v-if="!expanded(item)">  Cambia </div>

          </div>
        </div>


            <!--<div
                v-if="template.name === 'fermo-point'"
            >
                <div v-if="expanded(template.name)">
                    <point-delivery />
                </div>

                <div v-if="!expanded(template.name)">
                    <div>
                        <b>Punto di ritiro selezionato:</b>
                    </div>
                    <div v-if="address">
                        <div>{{ address.name }}</div>
                        <div>{{ address.street }}</div>
                        <div>{{ address.zip_code }}, {{ address.city }}</div>
                    </div>

                    <div v-else>
                        <div class="placeholder" v-for="n in 3" />
                    </div>
                </div>
           </div>-->

      <div class="flex flex-vcenter" v-if="isExpandedAny" >
        <div class="flex-fill"> </div>
        <slot name="cta-global" />
      </div>
   </div>
</template>

<script type="text/javascript">
import { scrollToElementId } from '../../assets/js/main'

import DeliveryHoursSelect from './DeliveryHoursSelect'
import SubscriptionForm from './SubscriptionForm'
import ShipmentSelect from './ShipmentSelect'
import PointDelivery from './PointDelivery'
import {DeliveryManager} from '../../core/delivery/DeliveryManager'
import OptionBox from '../Parts/OptionBox'
import Flash from '../Parts/Flash'
import { deliveryContainer } from '../../mixins/deliveryContainer'

import { subscriptionStore } from '../../store/subscriptionStore'
import { deliveryStore } from '../../store/deliveryStore'
import { milkmanStore } from '../../store/milkmanStore'
import { milkmanFreshFoodStore } from '../../store/milkmanFreshFoodStore'
import { orderStore } from '../../store/orderStore'
import { stepStore } from '../../store/stepStore'
import { dates } from '../../mixins/dates'
import DeliveryDaySelect from '../Delivery/DeliveryDaySelect'
import { deliverySelect } from '../../mixins/delivery'
import { shipmentZonesStore } from '../../store/shipmentZonesStore'

export default {
    props: {
        templates: {
            type: Array,
            default: () => {
              return [
                {
                    name: 'standard',
                    items: [
                        {
                            name: 'address',
                            label: 'Indirizzo di consegna',
                            labelInactive: 'Indirizzo di consegna',
                            price: '',
                            expanded: true,
                            enabled: ['name', 'city', 'zip_code', 'street', 'telephone', 'message']
                        }
                    ]
                },
                {
                    name: 'shipmentDay',
                    items: [
                        {
                            name: 'shipmentDay',
                            label: 'Giorno di consegna',
                            labelInactive: 'Giorno di consegna',
                            price: '',
                            expanded: true
                        }
                    ],
                },

                {
                  name: 'standard',
                  items: [
                    {
                      name: 'timeRange',
                      label: 'Seleziona una fascia oraria di consegna',
                      labelInactive: 'Le fasce orarie saranno selezionabili dopo aver inserito l\'indirizzo completo',
                      price: '',
                      expanded: true
                    },  
                  ]
                },
            ]
          }
        }
    },
    data () {
        return {
            loadingTimeRange: false,
            subscriptionStore: subscriptionStore.state,
            deliveryStore: deliveryStore.state,
            milkmanStore: milkmanStore.state,
            milkmanFreshFoodStore: milkmanFreshFoodStore.state,
            orderStore: orderStore.state,
            shipmentZonesStore: shipmentZonesStore.state,
            stepStore: stepStore.state,
            errorTimeRange: null
        }
    },

    mixins: [
        deliveryContainer,
        deliverySelect
    ],

    components: {
        DeliveryHoursSelect,
        SubscriptionForm,
        ShipmentSelect,
        PointDelivery,
        OptionBox,
        DeliveryDaySelect,
        Flash
    },

    watch: {
        updating () {
            if (!this.updating) {
                this.afterUpdate()
            }
        },

        '$_deliverySelect_getRealZoneShipment': {
            handler (newVal, oldVal) {
                let courier = null
                if(this.$_deliverySelect_getRealZoneShipment != null)  {
                    courier = this.$_deliverySelect_getRealZoneShipment.courier.name.toLowerCase()
                }
                if (newVal !== oldVal || !this.deliveryResolver.when()) {
                  this.milkmanHandler(courier)
                }
            },
            deep: true,
            immediate: true
        },

        'isFP': {
            handler (newVal, oldVal) {
                this.findCurrentMethod()
                this.updatePrice()
            },
            immediate: true 
        }
    },

    computed: {
        isExpandedAny() {
          for (var x in this.templates) {
            for (var y in this.templates[x].items) {
              if (this.expanded(this.templates[x].items[y])) {
                return true;
              }
            }
          }

          return false;
        },
        updating () {
            return this.stepStore.updating['subscription']
        },
        dateDelivery () {
            if (this.user.order && this.user.order.date) return this.$_dates_readableDate(this.user.order.date.delivery)
            return this.$_dates_nextWeekDay(this.user.subscription.delivery_day)
        },
        user () {
            return this.$root.user
        },
        
        address () {
            return this.delivery
                && this.deliveryStore
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
        },

        delivery () {
            var sub = this.user && this.user.subscription
            return sub 
                && this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
        },

        isFP () {
            return this.delivery
                && this.delivery.code
                && this.delivery.code.includes('FP')
        },

        loading () {
            return !this.delivery
        },

        hasDeliveryHours () {
            return ['mobi', 'milkman'].indexOf(this.subscriptionStore.shipment_type) !== -1
        },

        deliveryResolver() {
            return new DeliveryManager().getResolverByName(this.subscriptionStore.shipment_type)
        }
    },

    methods: {
        checked (template) {
            return false;
            if (template === 'standard') return this.subscriptionStore.delivery_type === 'standard'
            if (template === 'fermo-point') return this.subscriptionStore.delivery_type === 'fermo-point'
        },

        expanded (item) {
            return true;
            if (!this.user) return true
            if (!this.user.isSubscribed()) return true
            return item.expanded;
        },

        expand (item) {
            item.expanded = true
        },
        unexpand (item) {
          item.expanded = false
        },

        unexpandAll () {

            for (var x in this.templates) {
              for (var y in this.templates[x].items) {
                this.unexpand(this.templates[x].items[y])
              }
            }

            // this.templates.forEach(r => r.expanded = false) 
        },

        afterUpdate () {
            this.unexpandAll()
            this.updatePrice()
        },

        updatePrice () {
            if (!this.user) return
            if (!this.user.order) return
        },

        onDeliveryMethodChange () {
            subscriptionStore.updateSubscriptionParam({ param: 'message', value: null })
            subscriptionStore.updateSubscriptionParam({ param: 'street', value: null })
            subscriptionStore.updateSubscriptionParam({ param: 'code', value: null })
            subscriptionStore.updateSubscriptionParam({ param: 'point_name', value: null })

            // if switch from FP to standard
            if (this.subscriptionStore.delivery_type === 'standard' && this.delivery && this.address && !this.isFP) {
                subscriptionStore.updateSubscriptionParam({ param: 'street', value: this.address.street })
                subscriptionStore.updateSubscriptionParam({ param: 'message', value: this.delivery.notes })
                subscriptionStore.updateSubscriptionParam({ param: 'zip_code', value: this.address.zip_code })
                subscriptionStore.updateSubscriptionParam({ param: 'province', value: this.address.province })
                subscriptionStore.updateSubscriptionParam({ param: 'city', value: this.address.city })
                subscriptionStore.updateSubscriptionParam({ param: 'latitude', value: this.address.latitude })
                subscriptionStore.updateSubscriptionParam({ param: 'longitude', value: this.address.longitude })
            }

            this.$_deliveryContainer_loadDeliveries()

            this.templates.forEach(r => r.expanded = false)
        },

        findCurrentMethod () {
            this.subscriptionStore.delivery_type = (this.isFP)
                ? 'fermo-point'
                : 'standard'
        },

        toggle (target) {
          /*
            subscriptionStore.state.delivery_type = (target === 'fermo-point')
                ? 'fermo-point'
                : 'standard'
            this.onDeliveryMethodChange()
            */
        },

        updateSessionId (sessionId) {
            subscriptionStore.state.session_id = sessionId
        },

        milkmanHandler (courier) {
            if(!courier) {
                courier = this.subscriptionStore.shipment_type
            }
            this.errorTimeRange = null
            let option = this.$_deliverySelect_getRealZoneShipment;

            if (!option) {
                return;
            }


            let stores = {
                'milkman': milkmanStore,
                'milkmanfresh': milkmanFreshFoodStore
            };

            if (this.subscriptionStore && typeof stores[courier] !== "undefined") {
                this.loadingTimeRange = true;


                return stores[courier].callMilkman(option.delivery_date_shipped, option.delivery_date_estimated)

                .then(response => {
                    if (response) this.updateSessionId(response.body.result.sessionId)
                })

                .catch(response => { 
                    if(response && response == 'MILKMAN_API_INTERNAL_ERROR') {
                       this.errorTimeRange = response
                    }
                })
                .finally(i => {
                  this.loadingTimeRange = false;
                })
            } else {
                this.updateSessionId(null)
            }
        },

		isItemActive(item) {

      if (item.name != 'timeRange')
        return true;

      let courier = this.subscriptionStore.shipment_type

      if (courier != 'milkmanfresh')
        return true;

      let data = this.subscriptionStore.subscriptionParams
      let keys = ["latitude", "longitude", "street"]
      
      for (let i in keys) {
          let value = data[keys[i]]

          if (value == null || value == '')
            return false
      }

			return true;
		},

    getLabel(item) {
        return this.isItemActive(item) ? item.label : (item.labelInactive)
    }
    },
    created() {
        this.milkmanUpdate = function () {
            this.milkmanHandler();
        }

        window.addEventListener('shipment-zone-available.updated', this.milkmanUpdate);
    },
    destroyed () {
        window.removeEventListener('shipment-zone-available.updated', this.milkmanUpdate);
    }
}
</script>

<style scoped>
.delivery-option {
    max-width: 700px;
}
.delivery-option-content {
    padding: 10px 0px;
}

.map {
    position: relative;
    width: 100%;
    height: 400px;
}

.placeholder {
    background: #ededed;
    height: 15px;
    margin: 7px 0;
}

.placeholder:nth-child(3n-2) {
    width: 200px;
}

.placeholder:nth-child(3n-1) {
    width: 150px;
}
   
.placeholder:nth-child(3n) {
    width: 170px;
}

</style>